import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TicketService } from 'services/ticket/ticket.service';
import Ticket from 'models/ticket/ticket.model';
import { TicketAttributeService } from 'services/ticket-attribute/ticket-attribute.service';
import TicketAttribute from 'models/ticket-attribute/ticket-attribute.model';
import { BehaviorSubject } from 'rxjs';
import GeoJSONPoint from 'models/geojson-point/geojson-point.model';
import { ArcgisMapService } from 'services/arcgis-map/arcgis-map.service';
import { ProjectService } from 'services/project/project.service';
import Project from 'models/project/project.model';
import { MatSnackBar } from '@angular/material/snack-bar';
import ExternalLayer from 'models/external-layer/external-layer.model';

@Component({
  selector: 'app-update-ticket',
  templateUrl: './update-ticket.component.html',
  styleUrls: ['./update-ticket.component.scss'],
})
export class UpdateTicketComponent implements OnInit {
  @Input() pointsToShow: BehaviorSubject<GeoJSONPoint<{}>[]> = new BehaviorSubject([]);
  public tickets: Ticket[] = [];
  public project: Project = new Project();
  public ticketAttributes: TicketAttribute[] = [];
  public layerListSubject: BehaviorSubject<ExternalLayer[]> = new BehaviorSubject([]);

  constructor(
    private route: ActivatedRoute,
    public ticketAttributeService: TicketAttributeService,
    public arcgisMapService: ArcgisMapService,
    public snackBar: MatSnackBar,
    public router: Router,
    public projectService: ProjectService,
    public ticketService: TicketService,
  ) { }

  ngOnInit() {
    this.route.queryParams.subscribe(async params => {
      if (params.id) {
        await this.ticketService.select(params.id);
      }
    });
    this.ticketService.getSelectedInstance().subscribe(async ts => {
      this.tickets = ts;
      let points = [];
      ts.forEach(async (ticket, i) => {
        if (i === 0) {
          this.ticketAttributes = await this.ticketAttributeService.list(ticket.project);
        }
        points.push(ticket.position);
      })
      this.pointsToShow.next(points);
    });
    this.projectService.getSelectedInstance().subscribe(p => {
      this.project = p;
      this.layerListSubject.next(this.project.externalLayers);
    });
  }
}
